import {
  BET_OUTCOME_STATUS,
  BetState,
  STAKE_OUTCOME_STATUS,
  StakeState,
} from './constants';

// ---

/**
 * Detect stake outcome status depending on the `state`, `winning` and `amount` properties.
 */
export function getStakeOutcomeStatus(state: StakeState): symbol | undefined {
  switch (state) {
    case StakeState.ACTIVE:
      return STAKE_OUTCOME_STATUS.ACTIVE;

    case StakeState.RETURN:
      return STAKE_OUTCOME_STATUS.RETURNED;

    case StakeState.WIN:
      return STAKE_OUTCOME_STATUS.WON;

    case StakeState.LOSE:
      return STAKE_OUTCOME_STATUS.LOST;

    case StakeState.AWAITING:
      return STAKE_OUTCOME_STATUS.AWAITING;

    case StakeState.PAID:
      return STAKE_OUTCOME_STATUS.WON;

    case StakeState.CASH_OUT:
      return STAKE_OUTCOME_STATUS.CASHOUT;

    case StakeState.CANCEL:
      return STAKE_OUTCOME_STATUS.RETURNED;

    default:
      console.warn('unable to detect stake status', state); // >>>
  }
}

/**
 * Detect bet outcome status depending on the given `betState`.
 */
export function getBetOutcomeStatus(betState: BetState): symbol | undefined {
  switch (betState) {
    case BetState.ACTIVE:
      return BET_OUTCOME_STATUS.ACTIVE;

    case BetState.WIN:
      return BET_OUTCOME_STATUS.WON;

    case BetState.LOSE:
      return BET_OUTCOME_STATUS.LOST;

    case BetState.RETURN:
      return BET_OUTCOME_STATUS.RETURNED;

    case BetState.CANCEL:
      return BET_OUTCOME_STATUS.CANCELED;

    default:
      console.warn('unable to detect bet status', betState); // >>>
  }
}

// --

